import React from 'react';
import Typography from '../../../typography';
import { ErrorMessage } from './style';
export default function Error(props) {
  var {
    error,
    enableError,
    disableErrorMessage
  } = props;
  return /*#__PURE__*/React.createElement(ErrorMessage, {
    "data-test-id": 'text-input-error-message',
    showError: enableError && !disableErrorMessage
  }, /*#__PURE__*/React.createElement(Typography, {
    type: 'body6'
  }, enableError ? error : null));
}